import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN } from '../theme';

export const useTextStyles = makeStyles((theme: Theme) =>
  createStyles({
    h1: {
      fontSize: 32,
      lineHeight: '38px',
      fontWeight: 'bold',
      color: colorsPalette.white,
      [theme.breakpoints.up('md')]: {
        fontSize: 40,
        lineHeight: '48px',
      },
    },
    h2: {
      fontWeight: 'bold',
      color: colorsPalette.white,
      fontSize: 24,
      lineHeight: '28px',
      [theme.breakpoints.up('md')]: {
        fontSize: 28,
        lineHeight: '34px',
      },
    },
    h3: {
      fontWeight: 'bold',
      color: colorsPalette.white,
      fontSize: 18,
      lineHeight: '22px',
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
        lineHeight: '24px',
      },
    },
    h4: {
      fontWeight: 'bold',
      color: colorsPalette.white,
      fontSize: 18,
      lineHeight: '22px',
    },
    introText: {
      fontSize: 18,
      lineHeight: '24px',
      color: colorsPalette.gray,
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
        lineHeight: '30px',
      },
    },
    bodyText: {
      fontSize: 16,
      lineHeight: '26px',
      color: colorsPalette.gray,
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
      },
    },
    bodyIntro: {
      fontSize: 18,
      lineHeight: '24px',
      [theme.breakpoints.up('md')]: {
        fontSize: 20,
        lineHeight: '30px',
      },
    },
    metaLabel: {
      fontSize: 14,
      lineHeight: '18px',
      fontWeight: 'bold',
      color: colorsPalette.white,
    },
    meta: {
      fontSize: 14,
      lineHeight: '18px',
      color: colorsPalette.gray,
    },
  }),
);

export const useHtmlBlockStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      overflowX: 'auto',
      maxWidth: '100%',
      fontSize: 16,
      lineHeight: 1.5,
      color: colorsPalette.gray,
      '& h1,& h2,& h3,& h4,& h5,& h6,& p,& ul,& ol': {
        marginBottom: SMALL_MARGIN,
        marginTop: 0,
      },
      '& h1,& h2,& h3,& h4,& h5,& h6': {
        color: colorsPalette.white,
        lineHeight: 1.2,
      },
      '& ul, & ol': {
        paddingLeft: 20,
        '& li': {
          '&::marker': {
            color: colorsPalette.turquoiseLight,
          },
        },
      },
      '& a': {
        color: colorsPalette.white,
        '&:hover': {
          color: colorsPalette.blue,
        },
      },
      '& svg g': {
        fill: colorsPalette.white,
        stroke: colorsPalette.white,
      },
      [theme.breakpoints.up('md')]: {
        fontSize: 18,
      },
    },
  }),
);
